import React from 'react';
import { Link } from 'react-router-dom';
import { 
  Shield, Wifi, BadgeCheck, BookOpen, Waves, Utensils, ArrowRight 
} from 'lucide-react';
import { whyUsContent, features } from '../data/content';
import { Button } from './ui/button';

const iconMap = {
  Shield,
  Wifi,
  BadgeCheck,
  BookOpen,
  Waves,
  Utensils
};

export const WhyUsSection = () => {
  return (
    <section data-testid="why-us-section" className="section-spacing bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 relative overflow-hidden">
      {/* Background elements */}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-coral/20 rounded-full blur-3xl" />
      <div className="absolute bottom-0 right-1/4 w-72 h-72 bg-orange/10 rounded-full blur-3xl" />
      
      <div className="section-container relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div>
            <span className="inline-block px-4 py-2 bg-coral/20 text-coral rounded-full text-sm font-semibold mb-4">
              Why Choose Us
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-white font-['Outfit'] mb-6">
              {whyUsContent.title.replace('?', '')} <span className="text-coral">?</span>
            </h2>
            <p className="text-slate-300 text-lg leading-relaxed mb-8">
              {whyUsContent.description}
            </p>
            <Link to="/contact">
              <Button
                data-testid="why-us-apply-btn"
                className="bg-gradient-to-r from-coral to-orange hover:from-coral-dark hover:to-coral text-white rounded-full px-8 py-6 text-lg font-semibold shadow-lg shadow-coral/30"
              >
                Apply Now
                <ArrowRight className="w-5 h-5 ml-2" />
              </Button>
            </Link>
          </div>

          {/* Features Grid */}
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
            {features.map((feature) => {
              const Icon = iconMap[feature.icon] || Shield;
              return (
                <div
                  key={feature.id}
                  data-testid={`feature-${feature.id}`}
                  className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 text-center hover:bg-white/20 transition-colors border border-white/10"
                >
                  <div className="w-14 h-14 bg-coral/30 rounded-xl flex items-center justify-center mx-auto mb-4">
                    <Icon className="w-7 h-7 text-coral" />
                  </div>
                  <h3 className="text-2xl font-bold text-white font-['Outfit']">
                    {feature.title}
                  </h3>
                  <p className="text-slate-300 mt-1">{feature.subtitle}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
